export default api => ({
  getInitialConfig: async () => await api.get('/configurations')
});
